import React, { useEffect, useState } from 'react'
import { Input, Modal } from '@surecompanies/core_components'

export interface CancelBotPaymentModalProps {
  open: boolean
  benefitCount: number
  loading?: boolean
  onClose: () => void
  onConfirm: (reason: string) => void | Promise<void>
}

export function CancelBotPaymentModal({
  open,
  benefitCount,
  loading = false,
  onClose,
  onConfirm,
}: CancelBotPaymentModalProps) {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (open) {
      setReason('')
    }
  }, [open])

  const title =
    benefitCount > 1
      ? `Cancel bot payment (${benefitCount} selected)`
      : 'Cancel bot payment'

  const handleOk = () => {
    void onConfirm(reason.trim())
  }

  return (
    <Modal
      title={title}
      open={open}
      onCancel={loading ? undefined : onClose}
      onOk={handleOk}
      okText="Cancel payment"
      cancelText="Close"
      closable={!loading}
      maskClosable={!loading}
      cancelButtonProps={{ disabled: loading }}
      okButtonProps={{
        danger: true,
        loading,
      }}
      destroyOnClose
    >
      <p style={{ marginBottom: 12 }}>
        {benefitCount > 1
          ? 'This stops the queued bot payment for the selected benefits. You can optionally provide a reason for the activity log.'
          : 'This stops the queued bot payment for this benefit. You can optionally provide a reason for the activity log.'}
      </p>
      <Input.TextArea
        rows={3}
        placeholder="Cancellation reason (optional)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        maxLength={500}
        showCount
      />
    </Modal>
  )
}
